import React, { useContext, useState } from "react"
import { Modal, useModalHide } from "../../components/Modal";
import { useShortcut } from "../../utils/utils";
import { AccountContext } from "../AccountContext";
import { AccountSorter, SorterId } from "./account-sorting";

function SorterSelector({sorter}:{sorter: AccountSorter}){
    const {currentSorter, dispatch} = useContext(AccountContext);

    const downClass = currentSorter?.id == sorter.id && currentSorter?.order == 'asc' ? "btn-primary" : "btn-link";
    const upClass = currentSorter?.id == sorter.id && currentSorter?.order == 'desc' ? "btn-primary" : "btn-link";

    const hide = useModalHide();

    function selectSorter(order:string){
        if(order == 'asc' && downClass == 'btn-primary') return;
        if(order == 'desc' && upClass == 'btn-primary') return;

        dispatch({type: "setSorter", payload: {id: sorter.id, order}});
        hide();
    }

    if(sorter.id == 'otimizacao') return null;

    return <div className="sort-selector mb-2 d-flex">
        <span className="flex-grow-1">{sorter.name}</span>
        <button onClick={() => selectSorter("asc")} className={`ms-2 btn ${downClass} text-center px-0`} style={{width: "34px"}}><i className="fa-solid fa-arrow-down"></i></button>
        <button onClick={() => selectSorter("desc")} className={`ms-2 btn ${upClass} text-center px-0`} style={{width: "34px"}}><i className="fa-solid fa-arrow-up"></i></button>
    </div>
}

function SortingModal(){
    const {sorters, dispatch, groupingOn} = useContext(AccountContext);

    function toggleGrouping(){
        dispatch({type: "setGrouping", payload: !groupingOn});
    }

    return <>
        <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" checked={groupingOn} onChange={toggleGrouping} id="groupingOn" />
            <label className="form-check-label" htmlFor="groupingOn">
                Agrupar por região e estado
            </label>
        </div>
        <hr />
        {sorters.map(s => <SorterSelector key={s.id} sorter={s} />)}
    </>
}


export function SortingButton(){
    const {dispatch, groupingOn} = useContext(AccountContext);
    const [show, setShow] = useState(false);

    useShortcut("KeyS", () => setShow(true));
    useShortcut("KeyI", () => dispatch({type:"invertSort"}));
    useShortcut("KeyG", () => dispatch({type:"setGrouping", payload: !groupingOn}));
    useShortcut("KeyM", () => {
        dispatch({type:"setGrouping", payload: false})
        dispatch({type:"setSorter", payload: {id: "meta-proporcional", order: "asc"} as SorterId})
    });

    return <>
        <button onClick={(e) => {setShow(true); e.currentTarget.blur();}} className="ms-2 btn btn-link text-center px-0" style={{width: "34px"}}><i className="fa-solid fa-arrow-down-short-wide"></i></button>
        {show && <Modal className="modal-primary" onHide={() => setShow(false)} title="Classificação"><SortingModal /></Modal>}
    </>
}